export default __webpack_public_path__ + "static/media/abal.0cd298fc.svg";